import type { Maybe } from '@adornis/base/utilTypes.js';
import { GLOBAL_CONTEXT } from '@adornis/users/db/a-roles.js';
import type { UserRole } from '@ils/static/enums.js';
import type { User } from './permissions.js';

export const hasGlobalRole = (user: Maybe<User>, role: UserRole) => {
  if (!user) return false;
  return user.roles.some(urole => urole.contexts.includes(GLOBAL_CONTEXT) && urole.name === role);
};

export const hasRole = (user: Maybe<User>, role: UserRole) => {
  if (!user) return false;
  return user.roles.some(urole => urole.name === role);
};
